import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (ok) nav("/admin");
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url(https://images.pexels.com/photos/30283877/pexels-photo-30283877.jpeg)" }} />
        <div className="absolute inset-0 bg-black/60" />
        <div className="grain" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <span className="label-eyebrow text-[color:var(--nsa-orange)]">Area riservata</span>
          <div className="font-display uppercase text-6xl mt-3 leading-none">NSA<br/>Admin</div>
          <p className="text-white/70 max-w-md mt-4">Gestisci Racing Team, news, gallery e richieste in un unico pannello.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16 bg-white">
        <motion.form
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          onSubmit={submit}
          className="w-full max-w-md space-y-6"
          data-testid="admin-login-form"
        >
          <div>
            <span className="label-eyebrow text-gray-500 flex items-center gap-2"><Lock size={12} /> Login admin</span>
            <h1 className="font-display uppercase text-4xl mt-2">Accedi</h1>
          </div>
          <div>
            <label className="label-eyebrow text-gray-500 block mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="label-eyebrow text-gray-500 block mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3"
              data-testid="admin-password"
            />
          </div>
          {error && <div className="text-red-600 text-sm" data-testid="admin-login-error">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            className="btn-orange w-full label-eyebrow px-6 py-4 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? "Accesso..." : "ENTRA"}
          </button>
        </motion.form>
      </div>
    </div>
  );
}
